import { render, staticRenderFns } from "./DigitalSignatureDialog.vue?vue&type=template&id=01256fd8&scoped=true&"
import script from "./DigitalSignatureDialog.vue?vue&type=script&lang=js&"
export * from "./DigitalSignatureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01256fd8",
  null
  
)

export default component.exports